import { Brand, createBranded } from '@deltasierra/type-utilities';

export type AccessTokenId = Brand<number, 'AccessTokenId'>;
export const AccessTokenId = createBranded<AccessTokenId>();
